export default "__VITE_ASSET__DT0POaR7__"